import "./AgiosNikolaosResidenceRenovation.module.css";
import Header from "@/reusable_sections/Header";
import ProjectHeroImage from "./sections/ProjectHeroImage";
import ProjectDetails from "./sections/ProjectDetails";
import MainContent from "./sections/MainContent";
import Footer from "@/reusable_sections/Footer";
export default function AgiosNikolaosResidenceRenovationPage() {
  return <div>
      <Header />
      <ProjectHeroImage />
      <MainContent />
      <Footer />
    </div>;
}